import { getCroppedImageUrl } from '@/components/common/CroppedImage';
import { CropConfigs } from '@/components/common/CroppedImage/types';
import { twMerge } from 'tailwind-merge';

type Props = {
  croppedImageOptions?: CropConfigs;
  className?: string;
} & ObjectType;

export default function Img(props: Props) {
  let { className, alt = 'Weee! - Groceries Delivered', src, croppedImageOptions, ...others } = props;

  return (
    <img
      className={twMerge(className)}
      src={getCroppedImageUrl(src, { devicePixelRatio: 2, ...croppedImageOptions })}
      alt={alt}
      {...others}
    />
  );
}
